import t from 'tcomb';

export function template(src: t.String, opt_settings: ?t.Object) {
  opt_settings = opt_settings || template.jsp;

  var tmpl = 'var __p=[],print=function(){__p.push.apply(__p,arguments);};' +
    'with(obj||{}){__p.push(\'' +
    src.replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
    .replace(opt_settings.interpolate, function(match, code) {
      return "'," + code.replace(/\\'/g, "'") + ",'";
    })
    .replace(opt_settings.evaluate || null, function(match, code) {
      return "');" + code.replace(/\\'/g, "'")
        .replace(/[\r\n\t]/g, ' ') + "__p.push('";
    })
    .replace(/\r/g, '\\r')
    .replace(/\n/g, '\\n')
    .replace(/\t/g, '\\t') + "');}return __p.join('');";

  return new Function('obj', tmpl); // eslint-disable-line no-new-func
}

template.jsp = {
  evaluate: /<%([\s\S]+?)%>/g,
  interpolate: /<%=([\s\S]+?)%>/g
};

template.mustache = {
  evaluate: /{{([\s\S]+?)}}/g,
  interpolate: /{{=([\s\S]+?)}}/g
};

var template_cache = {};

template.store = function(id, t) {
  template_cache[id] = t;
  return t;
};

template.of = function(id) {
  return template_cache[id];
};

// Da usare quando il sorgente del template non può contenere <, >
export function mustache(src) {
  return template(src, template.mustache);
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/template.js
 **/